"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localeMatcher = exports.convertISOCodeToNavigatorLanguage = exports.convertNavigatorLanguageToISOCode = void 0;
const intl_localematcher_1 = require("@formatjs/intl-localematcher");
const convertNavigatorLanguageToISOCode = (code) => code.replace("-", "_");
exports.convertNavigatorLanguageToISOCode = convertNavigatorLanguageToISOCode;
const convertISOCodeToNavigatorLanguage = (code) => code.replace("_", "-");
exports.convertISOCodeToNavigatorLanguage = convertISOCodeToNavigatorLanguage;
exports.localeMatcher = intl_localematcher_1.match;
//# sourceMappingURL=utils.js.map